import React, { useState } from "react";
import Loader from "../Loader/Loader";

export default function GrantsModal({ show, onClose, grantsData = [], doi }) {
  //   const [active, setActive] = useState("BibTeX");
  const [loading, setLoading] = useState(false);

  if (!show) return null;

  return (
    <>
      {/* Backdrop */}
      <div className="modal-backdrop fade show"></div>

      {/* Modal */}
      <div className="modal show d-block" onClick={onClose} tabIndex="-1">
        <div
          className="modal-dialog modal-dialog-top modal-md"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="modal-content">
            {/* Header */}
            <div className="modal-header">
              <h5 className="modal-title fs-6">
                Grants for :{" "}
                {grantsData && (
                  <a
                    href={`${doi}`}
                    target="_blank"
                    rel="noreferrer"
                    className="text-theme"
                  >
                    {doi.replace("https://doi.org/", "")}
                  </a>
                )}
              </h5>
              <button className="btn-close" onClick={onClose}></button>
            </div>

            {/* Body */}
            <div className="modal-body">
              {grantsData ? (
                <>
                  {/* Tabs */}
                  <ul className="list-unstyled mb-3">
                    {grantsData.map((grant, index) => (
                      <li key={index} className="mb-1">
                        <span className="fw-bold me-2">Grant ID :</span>
                        <span className="text-secondary">{grant}</span>
                      </li>
                    ))}
                  </ul>
                </>
              ) : (
                <Loader />
              )}
            </div>
            {/* Footer */}
            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={onClose}>
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
